define('lib/countries/localize-and-sort-countries',['require','lodash','../audio/create-localized-country'],function (require) {
    var _ = require('lodash');
    var createLocalizedCountry = require('../audio/create-localized-country');

    var sanitizeCountry = function (country) {
        return country
          .toLowerCase()
          .replace('ö', 'oe')
          .replace('ä', 'ae')
          .replace('ü', 'ue')
          .replace('ß', 'ss');
    };

    var localizeAndSortCountries = function (countries) {
        var result = [];
        if (countries && countries.length > 0) {
            result = _.map(countries.map(function (country) {
                return createLocalizedCountry(country);
            }).sort(function (prev, next) {
                if (!prev.sanitizedCountry) prev.sanitizedCountry = sanitizeCountry(prev.displayCountry);
                if (!next.sanitizedCountry) next.sanitizedCountry = sanitizeCountry(next.displayCountry);
                if (prev.sanitizedCountry === next.sanitizedCountry) {
                    return 0;
                }
                if (prev.sanitizedCountry < next.sanitizedCountry) {
                    return -1;
                }
                return 1;
            }), 'country');
        }
        return result;
    };

    return localizeAndSortCountries;
});

